
import { Component } from 'react';

class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // Opcional: enviar a un servicio de logs
    console.error('Error atrapado:', error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ textAlign: 'center', padding: '60px 24px' }}>
          <h2>Algo salió mal</h2>
          <p>Intenta recargar la página. </p>
          <h2>Si no funciona verifica tus extensiones del navegador :D</h2>
          <button onClick={() => window.location.reload()}>
            Recargar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;